import { View } from "@netent/playui";
import { IAdapterSetting } from "..";

export type IActionType = "UPDATE_GAME_SETTINGS" | "UPDATE_VIEW";

export interface IStoreAction {
  type: IActionType;
}

export interface IUpdateGameSettingsAction extends IStoreAction {
  value: IAdapterSetting[];
}

export interface IUpdateViewAction extends IStoreAction {
  value: View;
}

const updateGameSettings = (
  value: IAdapterSetting[]
): IUpdateGameSettingsAction => ({ type: "UPDATE_GAME_SETTINGS", value });

const updateView = (value: View): IUpdateViewAction => ({
  type: "UPDATE_VIEW",
  value
});

export const actions = {
  updateGameSettings,
  updateView
};
